module Meevo.Components.Controls {

    import ProductCategory = Meevo.Model.ProductCategory;

    interface IProductCriteria {
        includeActive: true;
        includeInactive: true | null;
    }

    interface IAdvancedSearch {
        CatId?: string;
        IncludeNotForSale: 0 | null;
    }

    interface IProductMoverScope extends ng.IScope {
        allSelected: boolean;
    }

    class MeevoProductMoverController {
        static $inject = [
            '$scope'
        ];

        public ngModel: angular.INgModelController;
        public productCategoryModel: ProductCategory;
        public includeDiscontinuedModel: boolean;
        public includeNotForSale: boolean;
        public criteria: IProductCriteria;
        public advancedSearch: IAdvancedSearch;

        public allSelected: boolean;

        get productsModel(): string[] {
            return this.ngModel.$viewValue;
        }

        set productsModel(v: string[]) {
            this.ngModel.$setViewValue(v);
            this.updateValidation();
        }

        constructor(private $scope: IProductMoverScope) {
            this.criteria = <IProductCriteria>{
                includeActive: true,
                includeInactive: null
            };
            this.advancedSearch = <IAdvancedSearch>{
                CatId: null,
                IncludeNotForSale: null
            };
        }

        onSearchParamsChanged() {

            this.advancedSearch = {
                CatId: this.productCategoryModel ? this.productCategoryModel.id : null,
                IncludeNotForSale: this.includeNotForSale ? 0 : null
            };
        }

        onCriteriaParamsChanged() {

            this.criteria = {
                includeActive: true,
                includeInactive: !!this.includeDiscontinuedModel ? true : null
            }
        }

        $onInit() {
            this.$scope.$watch(() => this.allSelected, (newValue) => {
                this.updateValidation();
            });
        }

        updateValidation() {
            this.ngModel.$setValidity('products', this.allSelected || (!!this.ngModel.$viewValue && this.ngModel.$viewValue.length > 0));
        }

    }

    class MeevoProductMoverDirective implements ng.IDirective {
        restrict = 'E';
        templateUrl = 'app/components/controls/product-mover/product-mover.directive.html';
        scope = {
            fullResponse: '=?',
            allSelected: '=?'
        };
        bindToController = true;
        controller = MeevoProductMoverController;
        controllerAs = '$ctrl';
        require = [
            'meevoProductMoverDirective',
            'ngModel'
        ];

        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            ngModel.$render = () => {
                self.ngModel = ngModel;
                self.$onInit();
            };
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoProductMoverDirective();
            };

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoProductMoverDirective', MeevoProductMoverDirective.factory());
}